import React from 'react';

class BankAccountForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bankName: '',
      accountName: '',
      accountNo: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.onAddBank(this.state);
    this.setState({ bankName: '', accountName: '', accountNo: '' });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} className="bank-account-form">
        <input
          type="text"
          name="bankName"
          placeholder="Bank Name"
          value={this.state.bankName}
          onChange={this.handleChange}
          required
        />
        <input
          type="text"
          name="accountName"
          placeholder="Account Name"
          value={this.state.accountName}
          onChange={this.handleChange}
          required
        />
        <input
          type="text"
          name="accountNo"
          placeholder="Account No"
          value={this.state.accountNo}
          onChange={this.handleChange}
          required
        />
        <button type="submit">Add Bank</button>
      </form>
    );
  }
}

export default BankAccountForm;
